import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=2834be40&"
import script from "./myWallet.vue?vue&type=script&lang=js&"
export * from "./myWallet.vue?vue&type=script&lang=js&"
import style0 from "./myWallet.vue?vue&type=style&index=0&lang=less&scroped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports